module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/common/confirmation-toggle/confirmation-toggle.component.sass
// module id = ./src/app/common/confirmation-toggle/confirmation-toggle.component.sass
// module chunks = main